// src/types/properties/PoolRooms.ts
var PoolRoomStatus = /* @__PURE__ */ ((PoolRoomStatus2) => {
  PoolRoomStatus2["Active"] = "active";
  PoolRoomStatus2["OutOfOrder"] = "out_of_order";
  return PoolRoomStatus2;
})(PoolRoomStatus || {});

export {
  PoolRoomStatus
};
